import { render, staticRenderFns } from "./videoNumber.vue?vue&type=template&id=0c918b51&scoped=true&"
import script from "./videoNumber.vue?vue&type=script&lang=js&"
export * from "./videoNumber.vue?vue&type=script&lang=js&"
import style0 from "./videoNumber.vue?vue&type=style&index=0&id=0c918b51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c918b51",
  null
  
)

export default component.exports